export type Mode =
  | 'none'
  | 'info'
  | 'change'
  | 'remove'
  | 'add'
  | 'data'
  | 'multiselect'

export const MODE_LIST: Mode[] = [
  // 'none',
  'info',
  'change',
  'remove',
  'add',
  'data',
  'multiselect',
]
